import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { BoldDecoration } from "./bold-decoration.js";
import { ColorDecoration } from "./color-decoration.js";
import { EmptyDecoration } from "./empty-decoration.js";
import { FontSizeDecoration } from "./font-size-decoration.js";
import { ItalicDecoration } from "./italic-decoration.js";
import { SketchDecoration } from "./sketch-decoration.js";
import { firstRight } from "./utils.js";
const _Decorations = class _Decorations {
  constructor(textDecorations) {
    this.decorations = textDecorations;
  }
  static of(decorations) {
    const textDecorations = (decorations || []).map(_Decorations.toTextDecoration);
    return new _Decorations(textDecorations);
  }
  static fromCustomStyle(customStyle) {
    const { color, backgroundColor, ...rest } = customStyle;
    const colorStyle = {
      color: color ?? "",
      backgroundColor: backgroundColor ?? ""
    };
    const styles = Object.entries(rest).map(([k, v]) => ({ [k]: v })).concat([colorStyle]);
    const textDecorations = styles.map(_Decorations.styleToDecoration);
    return new _Decorations(textDecorations);
  }
  static styleToDecoration(style) {
    return firstRight(style, _Decorations.empty, [
      [(s) => !!s.fontWeight, (s) => BoldDecoration.fromCustomStyle(s)],
      [(s) => !!s.fontSize, (s) => FontSizeDecoration.fromCustomStyle(s)],
      [(s) => !!s.fontStyle, (s) => ItalicDecoration.fromCustomStyle(s)],
      [(s) => !!s.color || !!s.backgroundColor, (s) => ColorDecoration.fromCustomStyle(s)]
    ]);
  }
  static toTextDecoration(decoration) {
    return firstRight(decoration, _Decorations.empty, [
      [(d) => d.type === Decoration_Type.BOLD, (d) => BoldDecoration.of(d)],
      [(d) => d.type === Decoration_Type.ITALIC, (d) => ItalicDecoration.of(d)],
      [(d) => d.type === Decoration_Type.FONT_SIZE, (d) => FontSizeDecoration.of(d)],
      [(d) => d.type === Decoration_Type.COLOR, (d) => ColorDecoration.of(d)],
      [(d) => d.type === Decoration_Type.SKETCH, (d) => SketchDecoration.of(d)]
    ]);
  }
  toDecorationArray() {
    return this.decorations.filter((d) => d.type !== Decoration_Type.UNRECOGNIZED).map((d) => d.getDecoration());
  }
  byType(type) {
    return this.decorations.find((d) => d.type === type) || _Decorations.empty;
  }
  toCustomStyle() {
    return this.decorations.reduce(
      (style, decoration) => ({
        ...style,
        ...decoration.toCustomStyle()
      }),
      {}
    );
  }
  overrideWith(decorations) {
    const textDecorations = decorations.map(_Decorations.toTextDecoration);
    const overridenDecorations = textDecorations.map(
      (decoration) => this.byType(decoration.type).overrideWith(decoration)
    );
    const types = overridenDecorations.map((decoration) => decoration.type);
    const mergedDecorations = this.decorations.filter((decoration) => !types.includes(decoration.type)).concat(overridenDecorations);
    return new _Decorations(mergedDecorations);
  }
};
_Decorations.empty = new EmptyDecoration();
let Decorations = _Decorations;
export {
  Decorations
};
//# sourceMappingURL=decorations.js.map
